import React, { useState } from "react";
import TableComponent from "../../../components/TableComponent/TableComponentFiltro";

export const Pensiones = () => {
  const cabeceras = [
    "Id", //0
    "Nombre", //1
    "Editar",
    "Eliminar",
  ];
  const [parametros] = useState({
    action: "datatable",
    table: "types_pensions",
    rows: "keyTypePension,nameTypePension", ///sin espacios y comas
    conditions: "enabled = 1",
    page: 0,
    records: 5,
    search: "",
    order: "",
  });

  return (
    <div>
      <TableComponent
        titulo="Tipos de Pensiones"
        cabecerasTabla={cabeceras}
        filtro={null}
        rutaCrear="/template/pensiones-nomina/crear"
        rutaEditar="/template/pensiones-nomina/editar"
        parametros={parametros}
      ></TableComponent>
    </div>
  );
};
export default Pensiones;
